export default __webpack_public_path__ + "static/media/mmhd-logo-dark.8c00ffba.png";